var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_7826",
    "data-name": "Group 7826",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    width: 29,
    height: 29,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path-11",
    d: "M.314,20,0,4.544A1.815,1.815,0,0,1,.5,3.252L3.623,0,6.754,3.265a1.815,1.815,0,0,1,.5,1.261L7.214,19.965A1.815,1.815,0,0,1,5.4,21.775H2.128A1.815,1.815,0,0,1,.314,20Z",
    transform: "translate(12.391 22.949) rotate(-135)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path-57",
    d: "M15.186,2a1.21,1.21,0,0,1,0,2.419H6.839A2.419,2.419,0,0,0,4.419,6.839V21.355a2.419,2.419,0,0,0,2.419,2.419H21.355a2.419,2.419,0,0,0,2.419-2.419V15.307a1.21,1.21,0,1,1,2.419,0v6.049a4.839,4.839,0,0,1-4.839,4.839H6.839A4.839,4.839,0,0,1,2,21.355V6.839A4.839,4.839,0,0,1,6.839,2Z",
    transform: "translate(0.419 0.419)",
    fill: "#fff",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserEditIcon);
export default __webpack_public_path__ + "static/media/userEditIcon.de11994ccb90fcc101b06930a130dc53.svg";
export { ForwardRef as ReactComponent };